// Strings of the nested chart of accounts, account numbering and posting policies (migrations 033 and 034,
// docs/chart-and-posting.md). Arabic marked "new" needs review by an Arabic copy editor.
export const CHART_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    chGroups: "Groups of accounts",
    chParentGroup: "Group above",
    chParentNone: "None (directly under the class)",
    chParentHint: "Groups can be nested to any depth. A group stays in the class of the group above it.",
    chGroupCode: "Group code",
    chGroupCodeHint: "Optional. Digits only. Group and account codes share one list: a code names one thing.",
    chPath: "Place in the chart",
    chDepth: "Level",
    chGroupsCount: "Groups beneath",
    chAccountsBeneath: "Accounts beneath",
    chNewGroup: "New group",
    chNewSubgroup: "New group beneath",
    chNewAccountHere: "New account here",
    chAutoCode: "Give the next code when saving",
    chSuggested: "Next code: {c}",
    chSuggestedNote: "A preview: the code is given when you save, so it may be the next free one if someone else saves first.",
    chUseSuggestion: "Use {c}",
    next_after_siblings: "One more than the highest code beneath this group, same length.",
    next_first_child: "The group's code followed by {n} digits (numbering settings).",
    next_no_segment_rule: "No code beneath this group yet, and the numbering settings have no rule for a first code. Type one.",
    next_parent_has_no_code: "This group has no code and nothing beneath it has one, so no code can be suggested. Type one, or give the group a code.",
    next_mixed_lengths: "The codes beneath this group have different lengths, so Delta does not choose. Next of each length: {c}.",
    next_exhausted: "No free code is left of this length beneath this group. Type a code, or change the numbering settings.",
    next_suggestions_off: "Suggestions are off in the numbering settings. Type a code.",
    chMoveTitle: "Move with its history?",
    chMoveBody: "{n} journal lines are beneath this. Moving keeps every entry, amount and code; the history will be counted under the new group in reports from now on.",
    chMoveOk: "Move",
    chClassLocked: "This account has journal lines, so it stays in its class.",
    chCycle: "A group cannot be placed beneath itself or a group beneath it.",
    chGroupClass: "The group above must be in the same class.",
    codeReleased: "This code was used before and is not given out again.",
    codeParentPrefix: "The code must start with the group's code.",
    codeTooLong: "The code is longer than the numbering settings allow.",
    manualCodeOff: "Typed codes are off in the numbering settings. Use the next code.",
    shorterThanExisting: "Codes in use are longer than this.",
    chNoSuggestion: "No code can be suggested here; type one.",
    chTooLarge: "The chart is too large to open whole. Open groups one at a time, or search.",
    chLoadMore: "Loading…",
    chSearchHits: "{n} found",
    chSearchMore: "Showing the first 200. Narrow the search.",
    chExpandAllNote: "Opens every group (up to 5,000 groups and accounts).",
    numTitle: "Account numbering",
    numIntro: "How Delta suggests the next account or group code. Existing codes are never changed.",
    numAutoSuggest: "Suggest the next code from the codes beneath the chosen group",
    numAllowManual: "Allow typing a code instead (checked the same way)",
    numSegment: "Digits a first code adds to its group's code",
    numSegmentNone: "No rule (no suggestion for a group's first code)",
    numMaxLength: "Longest code",
    numReuse: "Give out a released code again (a deleted account's code)",
    numPrefix: "A code must start with its group's code",
    numObserved: "What the current chart looks like",
    numLengths: "Account codes by length",
    numGroupsCode: "Groups with a code: {a} · without: {b}",
    numReleased: "Released codes kept out of use: {n}",
    numZeros: "Account codes with a leading zero: {n}",
    numOwnerOnly: "Only the business owner changes these settings.",
    numSaved: "Numbering settings saved",
    tbViewGroups: "Groups and accounts",
    tbView: "View",
    tbGroupRow: "Group",
    cfInherited: "From {g}: {a}",
    refCount_groups: "{n} groups",
    errGroupCycle: "A group cannot be placed beneath itself.",
    errMoveConfirm: "Confirm the move first.",
    errClassLocked: "This stays in its class.",
    errChartTooLarge: "The chart is too large to open whole.",
    errNoCodeSuggestion: "No code can be suggested here; type one."
  },
  ar: {
    chGroups: "مجموعات الحسابات", // new
    chParentGroup: "المجموعة الأعلى", // new
    chParentNone: "لا شيء (مباشرة تحت التصنيف)", // new
    chParentHint: "يمكن تداخل المجموعات إلى أي عمق. تبقى المجموعة في تصنيف المجموعة الأعلى.", // new
    chGroupCode: "كود المجموعة", // new
    chGroupCodeHint: "اختياري. أرقام فقط. أكواد المجموعات والحسابات قائمة واحدة: الكود يدل على شيء واحد.", // new
    chPath: "الموضع في الدليل", // new
    chDepth: "المستوى", // new
    chGroupsCount: "مجموعات تحتها", // new
    chAccountsBeneath: "حسابات تحتها", // new
    chNewGroup: "مجموعة جديدة", // new
    chNewSubgroup: "مجموعة جديدة تحتها", // new
    chNewAccountHere: "حساب جديد هنا", // new
    chAutoCode: "إعطاء الكود التالي عند الحفظ", // new
    chSuggested: "الكود التالي: {c}", // new
    chSuggestedNote: "معاينة فقط: يُعطى الكود عند الحفظ، وقد يكون الكود المتاح التالي إن حفظ غيرك أولًا.", // new
    chUseSuggestion: "استخدم {c}", // new
    next_after_siblings: "أعلى كود تحت هذه المجموعة زائد واحد، بنفس الطول.", // new
    next_first_child: "كود المجموعة متبوعًا بـ {n} أرقام (إعدادات الترقيم).", // new
    next_no_segment_rule: "لا يوجد كود تحت هذه المجموعة بعد، ولا قاعدة لأول كود في إعدادات الترقيم. اكتب كودًا.", // new
    next_parent_has_no_code: "لا كود لهذه المجموعة ولا لما تحتها، فلا يمكن اقتراح كود. اكتب كودًا أو أعطِ المجموعة كودًا.", // new
    next_mixed_lengths: "الأكواد تحت هذه المجموعة بأطوال مختلفة، فلا يختار Delta. التالي لكل طول: {c}.", // new
    next_exhausted: "لم يبق كود متاح بهذا الطول تحت هذه المجموعة. اكتب كودًا أو غيّر إعدادات الترقيم.", // new
    next_suggestions_off: "الاقتراح متوقف في إعدادات الترقيم. اكتب كودًا.", // new
    chMoveTitle: "النقل مع السجل؟", // new
    chMoveBody: "تحت هذا {n} من سطور القيود. النقل يحتفظ بكل قيد ومبلغ وكود، وسيُحسب السجل تحت المجموعة الجديدة في التقارير من الآن.", // new
    chMoveOk: "نقل", // new
    chClassLocked: "لهذا الحساب سطور قيود، فيبقى في تصنيفه.", // new
    chCycle: "لا يمكن وضع مجموعة تحت نفسها أو تحت مجموعة تحتها.", // new
    chGroupClass: "يجب أن تكون المجموعة الأعلى في التصنيف نفسه.", // new
    codeReleased: "استُخدم هذا الكود من قبل ولا يُعطى مرة أخرى.", // new
    codeParentPrefix: "يجب أن يبدأ الكود بكود المجموعة.", // new
    codeTooLong: "الكود أطول مما تسمح به إعدادات الترقيم.", // new
    manualCodeOff: "كتابة الكود متوقفة في إعدادات الترقيم. استخدم الكود التالي.", // new
    shorterThanExisting: "توجد أكواد مستخدمة أطول من هذا.", // new
    chNoSuggestion: "لا يمكن اقتراح كود هنا؛ اكتب كودًا.", // new
    chTooLarge: "الدليل أكبر من أن يُفتح كاملًا. افتح المجموعات واحدة تلو الأخرى أو ابحث.", // new
    chLoadMore: "جارٍ التحميل…", // new
    chSearchHits: "{n} نتيجة", // new
    chSearchMore: "تُعرض أول 200 نتيجة. ضيّق البحث.", // new
    chExpandAllNote: "يفتح كل المجموعات (حتى 5000 مجموعة وحساب).", // new
    numTitle: "ترقيم الحسابات", // new
    numIntro: "كيف يقترح Delta كود الحساب أو المجموعة التالي. لا تتغير الأكواد الموجودة أبدًا.", // new
    numAutoSuggest: "اقتراح الكود التالي من الأكواد تحت المجموعة المختارة", // new
    numAllowManual: "السماح بكتابة كود بدلًا منه (يُتحقق منه بنفس الطريقة)", // new
    numSegment: "عدد الأرقام التي يضيفها أول كود إلى كود مجموعته", // new
    numSegmentNone: "لا قاعدة (لا اقتراح لأول كود في المجموعة)", // new
    numMaxLength: "أطول كود", // new
    numReuse: "إعطاء كود مُفرج عنه مرة أخرى (كود حساب محذوف)", // new
    numPrefix: "يجب أن يبدأ الكود بكود مجموعته", // new
    numObserved: "شكل الدليل الحالي", // new
    numLengths: "أكواد الحسابات حسب الطول", // new
    numGroupsCode: "مجموعات لها كود: {a} · بلا كود: {b}", // new
    numReleased: "أكواد مُفرج عنها ومستبعدة من الاستخدام: {n}", // new
    numZeros: "أكواد حسابات تبدأ بصفر: {n}", // new
    numOwnerOnly: "مالك المنشأة وحده يغيّر هذه الإعدادات.", // new
    numSaved: "حُفظت إعدادات الترقيم", // new
    tbViewGroups: "المجموعات والحسابات", // new
    tbView: "العرض", // new
    tbGroupRow: "مجموعة", // new
    cfInherited: "من {g}: {a}", // new
    refCount_groups: "{n} مجموعات", // new
    errGroupCycle: "لا يمكن وضع مجموعة تحت نفسها.", // new
    errMoveConfirm: "أكّد النقل أولًا.", // new
    errClassLocked: "يبقى هذا في تصنيفه.", // new
    errChartTooLarge: "الدليل أكبر من أن يُفتح كاملًا.", // new
    errNoCodeSuggestion: "لا يمكن اقتراح كود هنا؛ اكتب كودًا." // new
  }
};
